import logo from '../../../img/erecht24_logo_standard_version_dark.svg';

export default function () {
    return <div className="flex flex-row justify-center lg:hidden">
        <img src={logo} alt="e-Recht24" className="w-[150px] mt-6"/>
    </div>
}
